module.exports = "<section class=\"app-footer\">\n  <div class=\"container-fluid\">\n    <span class=\"float-left\">\n      <span>Copyright © {{AppConfig.brand}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Version {{version}}</span>\n    </span>\n    <!-- <span class=\"float-right\">\n      <span>Built with Love <i class=\"material-icons\">favorite_border</i></span>\n    </span> -->\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = 1338
// module chunks = 32